/* eslint-disable prettier/prettier */
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';
import LOGO from '&assets/images/background.jpg';
import { colors } from '&assets/constants/colors';

interface Props {
	backgroundImage: any;
}

export const LandingHeaderWrapper = styled.div<Props>`
	padding-top: 100px;
	.content {
		box-sizing: border-box;
		padding: 50px 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-position: center;
		width: 100%;
		height: 666px;
		background-image: url(${(props) => props.backgroundImage});
		background-repeat: no-repeat;
		background-size: cover;
		position: relative;
		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 29, 245, 0.2);
		}
		.submit-header {
			z-index: 1;
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		margin-top: 200px;
	}
	.title {
		font-family: 'Signifier-Regular';
		font-size: 3.75rem;
		line-height: 64px;
		color: ${colors.white};
		z-index: 1;
		margin: 0;
	}

	.sub-title {
		font-size: 24px;
		font-style: normal;
		line-height: 28px; /* 116.667% */
		letter-spacing: -0.6px;
		color: ${colors.white};
		z-index: 1;
	}
	.aws-logo {
		width: 155px;
		margin-bottom: 50px;
	}

	@media ${device.tablet} {
		padding-top: 85px;
		.content {
			padding: 20px;
			.title {
				width: auto;
				font-size: 2.75rem;
				margin-bottom: 30px;
			}
			.cards {
				flex-direction: column;
				padding: 0x;
				align-items: center;
			}
		}
	}

	@media ${device.mobile} {
		padding-top: 85px;

		.content {
			padding: 20px;
			.title {
				width: auto;
				font-size: 2.75rem;
				margin-bottom: 30px;
			}
			.cards {
				flex-direction: column;
				padding: 0px;
				align-items: center;
			}
			.powered {
				.sub-title {
					font-size: 1.5rem;
					line-height: 3rem;
					color: ${colors.white};
				}
			}
		}
	}
`;
